import React from 'react';
import { Flex } from '@chakra-ui/react';
import { ActiveGoalsWidget } from 'src/features/Goals/components/molecules/ActiveGoalsWidget';

export const GenAIActionButtons: React.FC = () => {
  return (
    <Flex
      alignItems={{ base: 'stretch', lg: 'end' }}
      direction={{ base: 'column', lg: 'row' }}
      w={{ base: '100%', lg: 'auto' }}>
      <ActiveGoalsWidget />
    </Flex>
  );
};
